/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForGithubCopilot extends models.GovernanceConfigurationBaseForGithub {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForGithubCopilot");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForGithubCopilot.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForGithubCopilot>): GovernanceConfigurationForGithubCopilot {
        let obj = Object.assign(new GovernanceConfigurationForGithubCopilot(), model);
        GovernanceConfigurationForGithubCopilot.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForGithubCopilot>): GovernanceConfigurationForGithubCopilot {
        if (!model) return null;
        return GovernanceConfigurationForGithubCopilot.newInstance(<GovernanceConfigurationForGithubCopilot> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForGithubCopilot) {
        if (!obj) return;

        models.GovernanceConfigurationForGithubCopilot.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForGithubCopilot): boolean {
        if (models.GovernanceConfigurationBaseForGithub.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForGithubCopilot.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies if GitHub Copilot governance metrics collection is enabled
     */
    enabled: boolean;

}
